export default __webpack_public_path__ + "static/B0161-b7a2c2f0b3621a06e0145e91bbc1db92.png";